import React from 'react'
import { useDispatch } from 'react-redux'
import { redirect } from 'redux-first-router'
import * as R from 'ramda'

export const Redirect = ({ action }) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (R.not(action)) return

    dispatch(redirect(action()))
  }, [action, dispatch])

  return null
}
